<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/products/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>
    <template v-else-if="products.length">
      <b-form-group :label="$t('pages.products.chooseCategory')" class="products-list-select">
        <v-select
          v-model="selectedCategory"
          :options="categories"
          :reduce="(ct) => ct.id"
          label="name"
          :disabled="reqLoading"
        />
      </b-form-group>

      <data-list-item :products="products" @update="fetchProducts" />
      <b-row v-if="numberOfPages > 0">
        <b-colxx xxs="12">
          <b-pagination-nav
            size="sm"
            :number-of-pages="numberOfPages"
            :link-gen="linkGen"
            v-model="page"
            :per-page="perPage"
            align="center"
          >
            <template v-slot:next-text>
              <i class="simple-icon-arrow-right" />
            </template>
            <template v-slot:prev-text>
              <i class="simple-icon-arrow-left" />
            </template>
            <template v-slot:first-text>
              <i class="simple-icon-control-start" />
            </template>
            <template v-slot:last-text>
              <i class="simple-icon-control-end" />
            </template>
          </b-pagination-nav>
        </b-colxx>
      </b-row>
    </template>
    <no-data v-else />
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/Products/DataList.vue'
import NoData from '@/components/Common/Messages/NoData'
import { handleArrayDataInternalization } from '@/utils'

export default {
  components: { DataListItem, NoData },
  data() {
    return {
      selectedCategory: this.$route.query.category || '',
      page: this.$route.query.page || 1,
      perPage: 10,
      numberOfPages: 1,
      apiBase: '/api/dashboard/product'
    }
  },
  computed: {
    isLoadingFileManager() {
      return this.$store.getters['fileManager/isLoading']
    },
    apiUrl() {
      const page = this.$route.query.page
      const search = this.$route.query.search || ''
      const category = this.$route.query.category || ''
      return `${this.apiBase}?page=${page}&search=${search}&category_id=${category}`
    },
    isLoading() {
      return this.$store.getters['products/isLoading']
    },
    reqLoading() {
      return this.$store.getters['products/reqLoading']
    },
    products() {
      const products = this.$store.getters['products/products']
      return handleArrayDataInternalization(products, ['name', 'content'], this.$i18n.locale)
    },
    categories() {
      const categories = this.$store.getters['products/categories']
      return handleArrayDataInternalization(categories, ['name'], this.$i18n.locale)
    }
  },
  async mounted() {
    await this.fetchProducts()
    await this.$store.dispatch('products/fetchRequirements')
  },
  methods: {
    linkGen(pageNum) {
      return {
        query: {
          ...this.$route.query,
          page: pageNum
        }
      }
    },
    async fetchProducts() {
      await this.$store.dispatch('products/fetchProducts', { vm: this })
    }
  },
  watch: {
    selectedCategory(category) {
      this.$router.replace({ query: { ...this.$route.query, category } })
    },
    $route() {
      if (Object.keys(this.$route.query).length) {
        this.fetchProducts()
      }
    }
  }
}
</script>

<style scoped>
.products-list-select {
  max-width: 300px;
  margin-bottom: 1.5rem !important;
}
</style>
